module.exports = __webpack_public_path__ + "img/DTYLX_de.d48eb3b1.png";